

































import { Vue, Component, Watch } from 'vue-property-decorator';
import UserModule from '@/store/modules/user';

@Component({
  components: {},
})
export default class StatsSidebar extends Vue {
  private sideNavigation = [
    {
      title: 'Market Portfolio',
      route: {
        name: 'market-stats',
      },
    },
    {
      title: 'Onboarding Statistics',
      route: {
        name: 'onboarding-stats',
      },
    },
    {
      title: 'Scheduler Statistics',
      route: {
        name: 'scheduler-statistics',
      },
    },
    {
      title: 'Document Statistics',
      route: {
        name: 'document-stats',
      },
    },
    {
      title: 'Users Statistics',
      route: {
        name: 'user-stats',
      },
    },
  ];

  private partnerNavigation = [
    {
      title: 'Scheduler Statistics',
      route: {
        name: 'scheduler-statistics',
      },
    },
    {
      title: 'Document Statistics',
      route: {
        name: 'document-stats',
      },
    },
  ];

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }

  get patnerUser() {
    if (UserModule.currentRole === 'partner_owner') {
      return UserModule.currentRole;
    }
    return null;
  }
}
